webpackJsonp([212839066777427],{

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      _react2.default.createElement(
	        'u',
	        null,
	        'Latest Posts'
	      )
	    ),
	    data.allMarkdownRemark.edges.map(function (post) {
	      return _react2.default.createElement(
	        'div',
	        { key: post.node.id },
	        _react2.default.createElement(
	          'h3',
	          null,
	          post.node.frontmatter.title
	        ),
	        _react2.default.createElement(
	          'small',
	          null,
	          'Posted by ',
	          post.node.frontmatter.author,
	          ' on',
	          ' ',
	          post.node.frontmatter.date
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          post.node.excerpt,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: post.node.frontmatter.path },
	            '\xA0Read More.'
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement('hr', null)
	      );
	    })
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = BlogPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-22b67e45e8d92ef593e0.js